export const API_URL = 'https://www.dbhubs-api.com';
//export const API_URL = 'http://localhost:3000';

// live maybe?
export const PLAN_ID_ANNUAL = 'P-5S988965BA358691CM4QRP6Q';
export const PLAN_ID_MONTHLY = 'P-7RC80220TV336205RM4QRPLI';

export const STRIPE_PUBLIC_KEY = 'pk_live_51OkAH3BrGCEER5W27d0Vqvw3QrG1NfvjFNH38PKL1WWwe0zZVNBOfHWb4r2yrmWsew73UXXBJ6qqbw49FMH9HdGb00V6uGtpCg';